export default __webpack_public_path__ + "static/media/nft2.9e8a6a20.png";